var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "error-a",
    d: "M13.1049107,12 L15.3392857,14.2098214 C15.6369055,14.5267873 15.6369055,15.0238041 15.3392857,15.3392857 C15.0238041,15.6369055 14.5267873,15.6369055 14.2098214,15.3392857 L12,13.1049107 L9.79017857,15.3392857 C9.47321275,15.6369055 8.97619586,15.6369055 8.66071429,15.3392857 C8.36309447,15.0238041 8.36309447,14.5267873 8.66071429,14.2098214 L10.8950893,12 L8.66071429,9.79017857 C8.36309447,9.47321275 8.36309447,8.97619586 8.66071429,8.66071429 C8.97619586,8.36309447 9.47321275,8.36309447 9.79017857,8.66071429 L12,10.8950893 L14.2098214,8.66071429 C14.5267873,8.36309447 15.0238041,8.36309447 15.3392857,8.66071429 C15.6369055,8.97619586 15.6369055,9.47321275 15.3392857,9.79017857 L13.1049107,12 L13.1049107,12 Z M12,23 C5.92486775,23 1,18.0751322 1,12 C1,5.92486775 5.92486775,1 12,1 C18.0751322,1 23,5.92486775 23,12 C23,18.0751322 18.0751322,23 12,23 Z M12,21.4285714 C17.2072562,21.4285714 21.4285714,17.2072562 21.4285714,12 C21.4285714,6.79274379 17.2072562,2.57142857 12,2.57142857 C6.79274379,2.57142857 2.57142857,6.79274379 2.57142857,12 C2.57142857,17.2072562 6.79274379,21.4285714 12,21.4285714 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "error-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#error-a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E70102",
    mask: "url(#error-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "matrix(1 0 0 -1 0 24)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.78b69fe9.svg";
export { ForwardRef as ReactComponent };